import React from 'react';
import { Row, Col, Image, Typography } from 'antd';
import title_handmade from "./assets/svg/title_handmade.svg";
import Citation from "./Citation.jsx";

const { Text } = Typography;

export default function CollectionAbout(props) {

    return (
        <div id="about" className="container">
          <Image src={title_handmade} height={"170px"} preview={false}/>
          <div>
            <Citation 
                citation="For I am the soul of Nature Who gives life to the Universe. From Me all things proceed, and unto Me they must return."
                author="D. Valiente"
            />
            <Row>
                <Col md={24} sm={24}>
                <Image className="nftgallery-img" src="img/dummy-about-500-667.jpg" preview={false}/>
                </Col>
            </Row>
            <p className="timeline-text">
                High-quality art{"\n"}
            </p>
            <p className="timeline-text">
                A <span className="emphasis">great</span> utility!
            </p>
          </div>
        </div>
    );
  }
  